/**
 * Country mismatch banner. Renders when the IP-detected country differs
 * from the customer's saved/chosen country. Offers a single-tap switch
 * and a close (×) button to dismiss for this detected country.
 */
import { X } from "lucide-react";
import { useCountry } from "../contexts/CountryContext";

const PRETTY = {
  IN: "India", US: "United States", CA: "Canada", GB: "United Kingdom",
  DE: "Germany", FR: "France", NL: "Netherlands", BE: "Belgium", IT: "Italy",
  ES: "Spain", AT: "Austria", SG: "Singapore", JP: "Japan", KR: "South Korea",
  NZ: "New Zealand", AE: "UAE", SA: "Saudi Arabia", MY: "Malaysia",
  TH: "Thailand", BR: "Brazil", MX: "Mexico", ZA: "South Africa",
  ID: "Indonesia", PH: "Philippines", CH: "Switzerland", NO: "Norway",
  DK: "Denmark", SE: "Sweden", FI: "Finland", IS: "Iceland", LU: "Luxembourg",
};

const CountryBanner = () => {
  const { detectedCountry, country, setCountry, showSwitchBanner, dismissBanner } = useCountry();

  if (!showSwitchBanner) return null;

  const detectedLabel = PRETTY[detectedCountry] || detectedCountry;
  const currentLabel = PRETTY[country] || country;

  return (
    <div
      className="bg-[#1A1A1A] text-white text-sm py-2.5 px-4 flex items-center justify-center gap-3 flex-wrap"
      data-testid="country-banner"
    >
      <span>
        Looks like you&apos;re in <strong>{detectedLabel}</strong>. You&apos;re
        currently viewing <strong>{currentLabel}</strong> prices.
      </span>
      <button
        type="button"
        onClick={() => setCountry(detectedCountry)}
        className="bg-white text-[#1A1A1A] px-3 py-1 text-xs font-medium hover:bg-[#FAF6EF]"
        data-testid="country-banner-switch"
      >
        Switch to {detectedLabel}
      </button>
      <button
        type="button"
        onClick={dismissBanner}
        className="text-white/70 hover:text-white"
        aria-label="Dismiss"
        data-testid="country-banner-close"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default CountryBanner;
